import React from 'react';
import ReactDOM from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';
import './css/index.css';
import './css/text-animation.css';
import App from './App';

smoothscroll.polyfill();

ReactDOM.render(<App />, document.getElementById('root'));
